import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18n from "i18n";
import { AIConfiguredModelProviders } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { invalidateModelProviders } from "./fetchModelProviders";
const useSetDefaultModelProvider = () => {
  const queryClient = useQueryClient();
  const sendTelemetry = useSendTelemetry();
  const { mutateAsync } = useMutation({
    mutationFn: (provider) => AIConfiguredModelProviders.setDefaultProvider(provider),
    onSuccess: (_result, provider) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.AI_MANAGEMENT.MODEL_PROVIDER_DEFAULT_SET, {
        app_section: "ai-management-model-providers",
        event_details: { provider }
      });
      UserNotification.success(i18n.t("notifications.default_changed", { ns: "enterprise_ai" }));
      invalidateModelProviders(queryClient);
    },
    onError: (error) => UserNotification.error(
      i18n.t("notifications.default_change_failed", { ns: "enterprise_ai", message: error.message })
    )
  });
  return { setDefault: mutateAsync };
};
export default useSetDefaultModelProvider;
